/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface WindowTransmissionDetailsUIDTOV0 { 
    dataSource?: WindowTransmissionDetailsUIDTOV0.DataSourceEnum;
    uValue?: number;
    solarTransmittance?: number;
}
export namespace WindowTransmissionDetailsUIDTOV0 {
    export type DataSourceEnum = 2 | 4;
    export const DataSourceEnum = {
        NUMBER_2: 2 as DataSourceEnum,
        NUMBER_4: 4 as DataSourceEnum
    };
}


